import { render, staticRenderFns } from "./ProductionTraceability.vue?vue&type=template&id=00f5009a&scoped=true"
import script from "./ProductionTraceability.vue?vue&type=script&lang=js"
export * from "./ProductionTraceability.vue?vue&type=script&lang=js"
import style0 from "./ProductionTraceability.vue?vue&type=style&index=0&id=00f5009a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5009a",
  null
  
)

export default component.exports